/*
[GNU Affero General Public License (AGPL)](https://www.gnu.org/licenses/agpl-3.0.html)

VeloceUI - A UI component library for Angular v17+ made with care by Colibryx Srl in Italy.
Copyright (C) 2025 Colibryx S.r.l.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

This license applies to any accompanying files located directly in the same directory.

For any inquiry, please contact Colibryx S.r.l. at info@colibryx.com.
*/

import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, input, model, output } from "@angular/core";
import { RouterModule } from "@angular/router";
import { IconComponent } from "@app/widgets/base/icon/icon.component";
import { TranslateModule } from "@ngx-translate/core";
import { TooltipModule } from "../../floating/tooltip/tooltip.module";
import type { CbSidebarItem } from "../sidebar.component";

@Component({
	selector: "cb-nav-item",
	imports: [CommonModule, IconComponent, RouterModule, TranslateModule, TooltipModule],
	templateUrl: "./nav-item.component.html",
	styleUrl: "./nav-item.component.scss",
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavItemComponent {
	public readonly navItem = input.required<CbSidebarItem>();
	public readonly isOpen = model<boolean>();
	public readonly compact = model<boolean>(false);
	public readonly theme = input<"light" | "brand" | "dark" | "white">("dark");

	public readonly size = input<"sm" | "md">("md");

	public readonly activationChange = output<boolean>();

	ngOnInit() {
		const navItem = this.navItem();
		if (navItem.type === "collapsible") {
			this.isOpen.set(navItem.isOpen ?? false);
		}
	}

	public activationChanged(isActive: boolean) {
		return this.activationChange.emit(isActive);
	}

	public clickSidebar() {
		const navItem = this.navItem();
		switch (navItem.type) {
			case "collapsible":
				this.isOpen.set(!this.isOpen());
				break;
			case "callback":
				navItem.callback();
				break;
			default:
				break;
		}
	}
}
